import React from 'react';
import PropTypes from 'prop-types';

import ManagedFormGroup from 'components/form/managed_input/form_group';

export default function PlanResetPeriod({ disabled, plan, onChange, ...props }) {
  return (
    <ManagedFormGroup
      disabled={disabled}
      label="Reset Period (years)"
      min="1"
      name="resetPeriod"
      required
      type="number"
      value={plan.resetPeriod || ''}
      onChange={onChange}
      {...props}
    />
  );
}

PlanResetPeriod.propTypes = {
  disabled: PropTypes.bool,
  plan: PropTypes.shape({
    resetPeriod: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
